import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const CHAVE_STORAGE = 'sidebar_expandida';

@Injectable({ providedIn: 'root' })
export class EstadoSidebarService {
  private readonly expandidaSubject = new BehaviorSubject<boolean>(
    this.lerValorInicial()
  );

  expandida$ = this.expandidaSubject.asObservable();

  obterValorAtual(): boolean {
    return this.expandidaSubject.value;
  }

  definir(expandida: boolean): void {
    this.expandidaSubject.next(expandida);
    try {
      localStorage.setItem(CHAVE_STORAGE, expandida ? '1' : '0');
    } catch {}
  }

  alternar(): void {
    this.definir(!this.obterValorAtual());
  }

  private lerValorInicial(): boolean {
    try {
      const v = localStorage.getItem(CHAVE_STORAGE);
      if (v === '0') return false;
      if (v === '1') return true;
    } catch {}
    return true; // padrão: aberta
  }
}
